import React, { useEffect, useState } from "react";
import DragDropChart from "../DragAndDrop";
import { useParams } from "react-router-dom";
import axios from "axios";
import { IoCaretDown, IoCaretUp } from "react-icons/io5";
import { TbArrowNarrowLeftDashed } from "react-icons/tb";

// import OrgChart  from '@dabeng/react-orgchart';
import { MdSubdirectoryArrowLeft } from "react-icons/md";

const LawMinerSectionsAndChapters = () => {
  const [openChild, setOpenChild] = useState(true);
  const [openChildLv2, setOpenChildLv2] = useState(true);
  const [openChildLv3, setOpenChildLv3] = useState(true);
  const [recordID, setRecordID] = useState(0);
  const [recordID2, setRecordID2] = useState(0);
  const [recordID3, setRecordID3] = useState(0);
  const horizontal = false;
  const collapsable = true;
  const expandAll = true;
  const [tdata, setData] = useState([]);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const result = await axios(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/Data/SubjectsTree?tabvib=true&addroot=true${
            params.id === null ? "" : "&parent=" + params.id
          }`
        );
        setData(result.data);
        // const x = result.data.find((i) => i.children.length > 0);
        // if (x !== undefined) {
        //   setRecordID(x.id);
        // }
        setLoading(false);
      } catch (error) {
        console.log("errorfetchDataSubjectsTree", error);
      }
    };

    fetchData();
  }, []);
  const handleOpen = (id) => {
    setOpenChild(!openChild);
    setRecordID(id);
  };
  const handleOpenLv2 = (id) => {
    setOpenChildLv2(!openChildLv2);
    setRecordID2(id);
  };
  const handleOpenLv3 = (id) => {
    setOpenChildLv3(!openChildLv3);
    setRecordID3(id);
  };
  return (
    <>
      <div
        // className={
        //   tdata.children !== undefined && tdata.children.length > 0
        //     ? "mt-48 w-[90%] pt-5  pb-32 mb-20 h-auto  bg-white border-2 rounded-lg flex flex-col rtl":""
        //     // : "mt-48 w-[90%] pt-5  pb-32 mb-20 h-[50vh]  bg-white border-2 rounded-lg flex flex-col rtl"
        // }
      >
        {/* <DragDropChart data={tdata} loading={loading} /> */}
        {/* <h1 className="text-center mb-3 font-bold text-IranSans text-[18px]">
          {tdata.name + " " + tdata.title}
        </h1> */}
        {tdata.children !== undefined ? (
          <>
            {tdata.children.map((i) => {
              return (
                <>
                  <div className="w-full text-justify flex flex-col px-5">
                    <div
                      className={`w-full bg-[#526E48] text-[18px]  p-2 text-white border-2  ${
                        i.children.length > 0
                          ? "hover:border-[#526E48] hover:bg-white hover:text-[#789461] cursor-pointer"
                          : ""
                      }`}
                      onClick={() => handleOpen(i.id)}
                    >
                      {i.children.length > 0 ? (
                        <>
                          <div className="flex items-center  ">
                            {i.name + "--" + i.title}
                            {openChild ? (
                              <IoCaretUp className="ml-2" />
                            ) : (
                              <IoCaretDown className="ml-2" />
                            )}
                          </div>
                        </>
                      ) : (
                        i.name + "--" + i.title
                      )}
                    </div>
                    {i.children.length > 0 && openChild ? (
                      i.children.map((j) => {
                        return (
                          <>
                            <div
                              className={`w-full ${
                                openChild
                                  ? "h-full duration-500 tansition-all"
                                  : "h-0"
                              }`}
                            >
                              {j.children.length > 0 ? (
                                <>
                                  <div
                                    onClick={() => handleOpenLv2(j.id)}
                                    className="flex items-center pr-8 text-[16px] py-3 	border-b-2 
                                    text-[#16423C] hover:bg-white hover:border-[#C1CFA1]  bg-[#C1CFA1] hover:border-2 hover: cursor-pointer "
                                  >
                                    <MdSubdirectoryArrowLeft className="text-xl text-[#526E48]" />
                                    {j.name + "--" + j.title}
                                    {openChildLv2 ? (
                                      <IoCaretUp className="ml-2" />
                                    ) : (
                                      <IoCaretDown className="ml-2" />
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="border-b-2 flex items-center border-white bg-[#C1CFA1] text-[#16423C]  pr-8 text-[16px] py-3">
                                    <MdSubdirectoryArrowLeft className="text-xl text-[#526E48]" />
                                    {j.name + "--" + j.title}
                                  </div>
                                </>
                              )}
                            </div>
                            {j.children.length > 0 && openChildLv2 ? (
                              <>
                                {j.children.map((k) => {
                                  return (
                                    <>
                                      <div
                                        className={
                                          k.children.length <= 0
                                            ? "w-full flex  items-center pr-12 text-[14px] border-b-2 border-dashed py-2 "
                                            : "w-full flex bg-[#D6EFD8]  items-center pr-12 text-[14px] border-b-2 border-dashed py-2 cursor-pointer hover:border-4 hover:border-[#D6EFD8] hover:bg-white"
                                        }
                                      >
                                        {k.children.lenght > 0 ? (
                                          <>
                                            <div
                                              onClick={() =>
                                                handleOpenLv3(k.id)
                                              }
                                              className="flex items-center pr-8 text-[16px] py-3 border-b-2  hover:bg-white hover:border-[#D6EFD8]  bg-[#D6EFD8] hover:border-2 cursor-pointer "
                                            >
                                              <MdSubdirectoryArrowLeft className="text-xl text-[#526E48]" />
                                              {k.name + "--" + k.title}
                                              {openChildLv3 ? (
                                                <IoCaretUp className="ml-2" />
                                              ) : (
                                                <IoCaretDown className="ml-2" />
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <MdSubdirectoryArrowLeft className="text-xl text-[#C1CFA1]" />
                                            {k.name + "--" + k.title}
                                          </>
                                        )}
                                      </div>
                                      {k.children.length > 0 ? (
                                        <>
                                          {k.children.map((l) => {
                                            return (
                                              <>
                                                <div className="w-full flex items-center py-2 border-b-2 border-dashed text-[12px] px-20">
                                                  <MdSubdirectoryArrowLeft className="text-xl text-[#D6EFD8]" />

                                                  {l.name + "--" + l.title}
                                                </div>
                                              </>
                                            );
                                          })}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  );
                                })}
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              );
            })}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default LawMinerSectionsAndChapters;
